<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="plant-storage-tab" :class="{ 'form-disabled': disabled }">
    <div class="row">
      <!-- Plant (FORM02: plant_storage_location.cat_emcr_plants) -->
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Plant <span v-if="isTableMandatory(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[PLANTS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="400px">
              <Column v-if="isColumnVisibleFn('plant', PLANTS_FIELD, PLANT_STORAGE_LOCATION_TAB)" header-class="bg-light text-center">
                <template #header>
                  Plant <span v-if="isColumnMandatoryFn('plant', PLANTS_FIELD, PLANT_STORAGE_LOCATION_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.plant" size="small" fluid filter
                    :options="dialog.options[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD, 'plant', data)]"
                    option-label="label" option-value="value" placeholder="Select Plant"
                    :loading="dialog.loading[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD, 'plant', data)]"
                    :invalid="isColumnInvalidFn(data, 'plant')"
                    :disabled="disabled || !isColumnEnabledFn('plant', PLANTS_FIELD, PLANT_STORAGE_LOCATION_TAB)"
                    @show="loadColumnOptions(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD, 'plant', data)"
                    @change="onColumnChange(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD, 'plant', data)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD, 'plant', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <!-- Kolom terkunci (`readonlyandsaved`, nilainya dari default_value config & tetap disimpan): Period Indicator
                   (cat_emcr_plants) dan No Costing / Variance Key (cat_emcr_costing_views -- barisnya = baris Plant, `rows_from`). -->
              <template v-for="col in LOCKED_PLANT_COLUMNS" :key="`${col.field}.${col.column}`">
                <Column v-if="isColumnVisibleFn(col.column, col.field, PLANT_STORAGE_LOCATION_TAB)" header-class="bg-light text-center" :style="{ width: '130px', minWidth: '130px' }">
                  <template #header>{{ col.label }}</template>
                  <template #body="{ data }">
                    <InputText :model-value="data[col.column] ?? ''" size="small" disabled fluid />
                  </template>
                </Column>
              </template>
              <Column v-if="canRemoveRow(PLANT_STORAGE_LOCATION_TAB, PLANTS_FIELD)" header-class="bg-light" style="width: 56px">
                <template #body="{ index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled" @click="removeRow(PLANTS_FIELD, index)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>

      <!-- Storage Location (FORM02: plant_storage_location.cat_emcr_locations) -->
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Storage Location <span v-if="isTableMandatory(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[LOCATIONS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="400px">
              <Column v-if="isColumnVisibleFn('plant', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)" header-class="bg-light text-center">
                <template #header>
                  Plant <span v-if="isColumnMandatoryFn('plant', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <!-- Opsi = plant yang sudah dipilih di tabel Plant (data_source detail_array, source "form"). -->
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.plant" size="small" fluid
                    :options="dialog.options[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'plant', data)]"
                    option-label="label" option-value="value" placeholder="Select Plant"
                    :invalid="isColumnInvalidFn(data, 'plant')"
                    :disabled="disabled || !isColumnEnabledFn('plant', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)"
                    @show="loadColumnOptions(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'plant', data)"
                    @change="onColumnChange(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'plant', data)"
                  >
                    <!-- Opsi detail_array baru dimuat saat dropdown dibuka; tanpa #value, nilai hasil hydrate tampil sebagai placeholder. -->
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'plant', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('location', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)" header-class="bg-light text-center">
                <template #header>
                  Storage Location <span v-if="isColumnMandatoryFn('location', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <!-- Opsi difilter plant BARIS ini (params ["client","plant"] + depends_on ["plant"]); di-cache per plant,
                     jadi baris lain dengan plant sama tidak memanggil API lagi (columnOptionsKey). -->
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.location" size="small" fluid filter
                    :options="dialog.options[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'location', data)]"
                    option-label="label" option-value="value" placeholder="Select Storage Location"
                    :loading="dialog.loading[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'location', data)]"
                    :invalid="isColumnInvalidFn(data, 'location')"
                    :disabled="disabled || !isColumnEnabledFn('location', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB) || !isColumnDependencyReadyFn('location', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB, data)"
                    @show="loadColumnOptions(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'location', data)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD, 'location', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('bin', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)" header-class="bg-light text-center">
                <template #header>
                  Bin Location <span v-if="isColumnMandatoryFn('bin', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <InputText v-model="data.bin" size="small" placeholder="Enter Bin" fluid
                    :disabled="disabled || !isColumnEnabledFn('bin', LOCATIONS_FIELD, PLANT_STORAGE_LOCATION_TAB)"
                    @input="data.bin = (data.bin || '').toUpperCase()"
                  />
                </template>
              </Column>
              <Column v-if="canRemoveRow(PLANT_STORAGE_LOCATION_TAB, LOCATIONS_FIELD)" header-class="bg-light" style="width: 56px">
                <template #body="{ index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled" @click="removeRow(LOCATIONS_FIELD, index)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";

// Key tab & field repeatable di FORM02_BASE.json
const PLANT_STORAGE_LOCATION_TAB = "plant_storage_location";
const PLANTS_FIELD = "cat_emcr_plants";
const LOCATIONS_FIELD = "cat_emcr_locations";
const COSTING_FIELD = "cat_emcr_costing_views";

// Kolom terkunci di tabel Plant (label & sumber field) -- layout; tampil & nilainya dari config FORM02.
const LOCKED_PLANT_COLUMNS = [
  { field: PLANTS_FIELD, column: "period_in", label: "Period Indicator" },
  { field: COSTING_FIELD, column: "no_costing", label: "No Costing" },
  { field: COSTING_FIELD, column: "variance_key", label: "Variance Key" }
];

// Props, setup engine, dialog, bind ke mcrItem (cat_emcr_plants/cat_emcr_locations sudah di-hydrate
// New_CataloguerForm): kerangka bersama New_CataloguerTab.js.
export default {
  name: "PlantStorageTab",
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props, (vm) => ({
      // data_source detail_array dengan source "form" (opsi Plant di tabel Location) dibaca dari state item ini.
      getDetailSources: () => ({ form: vm.dialog.form })
    }));
  },
  data() {
    return {
      PLANT_STORAGE_LOCATION_TAB,
      PLANTS_FIELD,
      LOCKED_PLANT_COLUMNS,
      LOCATIONS_FIELD,
      dialog: createTabDialog(this.mcrItem)
    };
  },
  methods: {
    // Hook kerangka bersama, dipanggil tiap item dipilih/berganti (setelah dialog.form = mcrItem & state opsi dikosongkan).
    // Label baris yang sudah terisi langsung tampil: 1 request per kunci unik (daftar plant sekali, location per plant).
    onItemBound() {
      this.ensureTableArrays(PLANT_STORAGE_LOCATION_TAB);
      this.preloadTabLabels(PLANT_STORAGE_LOCATION_TAB);
    }
  }
};
</script>
